<script>
    import { required, minLength } from "vuelidate/lib/validators";
    import General from '@/services/General';
    import ModalAddOptInTranslations from "@/components/modals/customers/modalAddOptInTranslations.vue";
    import Swal from "sweetalert2";

    export default {
      components: {ModalAddOptInTranslations},


        props: {
            item: {
                type: [Array, Object],
                default: null,
            },
        },


        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                demandOptions: ['delete'],
                demand: '',
                isBusy: false,
                source: 'dashboard',
                showModal: false,
                tryingToEdit: false,
                submitted: false,
                showInRegister: '1' ,
                parent: null,
                text : '' ,
                phone : '' ,
                email : '' ,
                uniqueSet: '' ,
                type : '' ,
                name : '' ,
                description : '' ,
                RemoveOptIns : '' ,
                selectedParent: null,
                id : '' ,
                show_in_register : '1' ,
                localization : [] ,
                perPage: 10,
                currentPage: 1,
                totalRows: 0,
                tableData: [],
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "description",
                sortDesc: true,
                modalData:[]


            };
        },


      computed: {
        tableFields() {
          return [
            { key: "name", label: "Key", sortable: true },
            { key: "language", label: "Language", sortable: true },
            { key: "description", label: "Description", sortable: true },
            { key: "action", label: "Action"},
          ];
        }
      },

      methods: {

        callModalAddOptInsTranslations(data) {
          this.modalData = data;
          this.$bvModal.show("add_optin_translation");
        },
          onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
          },
        syncData(){
          this.id = this.item.id;
          this.name = this.item.name;
          this.modalData = this.item

        },
        async getCustomerOptIns(status = 1) {
          this.syncData();
          try {
            this.toggleBusy && this.toggleBusy();
            const dataStatus = `status=${status}`;
            const response = await General.getSingleCrmOptIns(dataStatus,this.id);
            this.localization = response.data.data.localization;
            this.totalRows = response.data.data.localization.length;
            this.modalData = response.data.data;

          } catch (error) {
            this.error = error?.response?.data?.error || "";
            this.modalData = {};
            this.localization = [];
            this.totalRows = 0;
          } finally {
            this.toggleBusy && this.toggleBusy();
          }
        },

        removeOptInsTranslation(item){

          Swal.fire({
            title: "Remove this Opt In Translation?",
            text: "This Opt In Translation will be removed!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Remove!",
          }).then((result) => {
            if (result.value) {

              const formData = {
                localization: [
                  {
                    description: item.description,
                    language: item.language,
                    action: "remove"
                  }
                ]
              };
              try {
                this.toggleBusy();
                General.deleteCrmOptInTranslation(formData,this.id)
                    .then((response) => {
                      const res = response.data ? response.data : false;
                      const error = response.data.error ? response.data.error : 'Failed';
                      if(res){
                        this.syncAndRefresh()

                        Swal.fire("Remove Opt In Translation", "Opt In Translation is successfully removed!", "success");
                      }else{
                        Swal.fire("Fail!", error, "warning");
                      }
                    })
              }catch(error){
                this.error = error.response.data.error ? error.response.data.error : "";

              }finally {
                this.toggleBusy();
              }
            }
          });
        },
        syncAndRefresh() {
          this.getCustomerOptIns();
          this.syncData();
          this.$emit('onRefresh');
        },
        closeModal() {
          this.showModal = false;
          this.localization = []
          this.modalData = []
          this.totalRows = 0
        },
        }
    };
</script>

<template>
    <b-modal  @shown="getCustomerOptIns" @hidden="closeModal" size="lg" v-model="showModal" id="translate_optins"  title="Translate Opt Ins" title-class="font-18" centered>
        <form>
          <div class="row">
            <div class="col-12 col-md-12  float-start">
              <a @click="callModalAddOptInsTranslations(modalData)" href="javascript:void(0);" class="btn btn-success waves-effect waves-light">
                <i class="mdi mdi-plus me-2"></i>Add Translation
              </a>
            </div>
          </div>
            <div class="d-flex align-items-center justify-content-center">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <b-table
                :busy="isBusy"
                :items="localization"
                :fields="tableFields"
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                show-empty
                empty-text="No Data Found"
                @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <ul class="list-inline mb-0">


                  <li class="list-inline-item">
                    <a href="javascript:void(0);" class="px-2 text-danger"  title="Remove" @click="removeOptInsTranslation(data.item)">
                      <i class="uil uil-trash-alt font-size-18"></i>
                    </a>
                  </li>

                </ul>
              </template>

            </b-table>

          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>


            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>

        </template>
      <ModalAddOptInTranslations :item="this.modalData"  @onRefresh="syncAndRefresh" ></ModalAddOptInTranslations>
    </b-modal>

</template>